import { CHAT_REQUEST_STATUS } from '../../../src/shared/constants';

import {
  SEND_CHAT_FEEDBACK,
  SET_CHAT_OPENED_FROM,
  SET_CHAT_MINIMIZED,
  SET_CHAT_SHAKING,
  SET_CHAT_STATUS,
  CHAT_FEEDBACK_SUCCESS,
  SET_CHAT_WINDOW_CLOSABLE
} from '../app-communication/actions/from-client-frontend';

import {
  CHAT_ASSIGNED,
  CHAT_CLOSED_BY_ADMIN,
  CHAT_CLOSED_BY_OPERATOR,
  CONTINUE_CHAT,
  CHAT_NOT_EXISTS
} from '../app-communication/actions/from-cluster';

import { CHAT_NOT_EXISTS_REASONS } from '../../../src/shared/constants';

import { CHAT_STATE, CLEAR_STORE, TOGGLE_CHAT_SOUND, TOGGLE_CHAT_TRANSLATE } from '../constants';
import { SAVE_CHAT_STYLES } from '../constants/chat-drag';

const CHAT_REQUEST_TO_STATUS_MAP = {
  [CHAT_REQUEST_STATUS.REQUESTED]: CHAT_STATE.REQUESTING_CHAT,
  [CHAT_REQUEST_STATUS.ACCEPTED]: CHAT_STATE.IN_PROGRESS,
  [CHAT_REQUEST_STATUS.HOLD_BEFORE_REQUEST]: CHAT_STATE.REQUESTING_CHAT
};

export const initialState = {
  setting: {
    sound: true,
    translate: true,
    minimized: false,
    shaking: false,
    isChatWindowClosable: true
  },
  rate: 5,
  hideRatingScreen: null,
  state: CHAT_STATE.IDLE,
  requestId: null,
  feedbackSent: false,
  data: null,
  position: {
    left: null,
    top: null,
    width: null,
    height: null
  },
  feedback: {
    reviewHref: null,
    uaUrl: null,
    reviewOnclick: null,
    isReferral: null,
    refUrl: null,
    language_locale: null,
    referrerId: null,
    rating: null,
    entityIdentificator: null,
    clickValue: null,
    title: null,
    feedback_type: null
  }
};

export const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHAT_ASSIGNED:
      return {
        ...state,
        state: CHAT_STATE.IN_PROGRESS,
        requestId: action.payload.request_id,
        feedbackSent: false
      };
    case CONTINUE_CHAT:
      return {
        ...state,
        state: CHAT_REQUEST_TO_STATUS_MAP[action.payload.status],
        requestId: action.payload.requestId
      };
    case CHAT_CLOSED_BY_OPERATOR:
    case CHAT_CLOSED_BY_ADMIN:
      return {
        ...state,
        state: CHAT_STATE.ENDED
      };
    case CHAT_NOT_EXISTS:
      const reason = action.payload && action.payload.reason;

      if (reason === CHAT_NOT_EXISTS_REASONS.OPERATOR_LOST_CONNECTION) {
        return {
          ...state,
          state: CHAT_STATE.OPERATOR_LOST_CONNECTION
        };
      }

      if (reason === CHAT_NOT_EXISTS_REASONS.OPERATOR_ENDED_CHAT) {
        return {
          ...state,
          state: CHAT_STATE.ENDED
        };
      }

      return { ...state };
    case TOGGLE_CHAT_SOUND:
      return {
        ...state,
        setting: {
          ...state.setting,
          sound: Boolean(action && action.payload && action.payload.isSoundOn)
        }
      };
    case TOGGLE_CHAT_TRANSLATE:
      return {
        ...state,
        setting: {
          ...state.setting,
          translate: action.payload
        }
      };
    case SEND_CHAT_FEEDBACK:
      return {
        ...state,
        rate: action.payload.visitor_rating,
        feedbackSent: true
      };
    case CHAT_FEEDBACK_SUCCESS:
      const { result, ...rest } = action.payload;
      return {
        ...state,
        feedback: rest,
        hideRatingScreen: result && result.hide_rating_screen
      };
    case SET_CHAT_STATUS:
      return {
        ...state,
        state: action.payload
      };
    case SET_CHAT_MINIMIZED:
      return {
        ...state,
        setting: {
          ...state.setting,
          minimized: action.payload
        }
      };
    case SET_CHAT_SHAKING:
      return {
        ...state,
        setting: {
          ...state.setting,
          shaking: action.payload
        }
      };
    case SET_CHAT_WINDOW_CLOSABLE:
      return {
        ...state,
        setting: {
          ...state.setting,
          isChatWindowClosable: action.payload
        }
      };
    case SAVE_CHAT_STYLES:
      return {
        ...state,
        position: {
          left: action.payload.left,
          top: action.payload.top,
          width: action.payload.width,
          height: action.payload.height
        }
      };
    case SET_CHAT_OPENED_FROM:
      return {
        ...state,
        data: action.payload
      };
    case CLEAR_STORE:
      return {
        ...initialState
      };
    default:
      return state;
  }
};
